module.exports = __webpack_public_path__ + "img/home_arrow.9632ce02.png";